<!-- ================阅读拓展馆-博雅大语文详情====================-->
<template>
    <div class="bydyw-info-container">
        <home-head />
        <div class="bydyw-info-body">
            <div class="bydyw-info-inner" v-loading="loading">
                <!-- 标题区 -->
                <div class="bydyw-info-header">
                    <div class="back-btn" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回</span>
                    </div>
                    <div class="bydyw-info-title">{{ libraryInfo.className || '' }}</div>
                    <div class="bydyw-header-right">
                        <div class="book-actions">
                            <div class="action-btn" :class="{ active: isFavorite }" @click="handleFavorite" title="收藏">
                                <svg viewBox="0 0 1024 1024" width="22" height="22">
                                    <path d="M512 0l127.4 395.6H1024L639.3 640.4 766.7 1024 512 779.6 257.3 1024l127.4-383.6L0 395.6h384.6z" fill="currentColor"/>
                                </svg>
                            </div>
                            <div class="action-btn" :class="{ active: isLike }" @click="handleLike" title="点赞">
                                <svg viewBox="0 0 1024 1024" width="22" height="22">
                                    <path d="M884.2 396.6c-18.4-22.9-46.5-36.6-76.7-36.6h-188l21.6-117.8c8.6-46.8-3.8-95.4-34-132.4-28.2-34.6-69.8-54.4-113.8-54.4-54.2 0-102.8 31.4-125.6 80.4L299.6 270.2c-10.2 22.6-12.4 48.2-6.2 72.4l35.8 142.2H180.8c-56.8 0-102.8 46-102.8 102.8v281.2c0 56.8 46 102.8 102.8 102.8h532.4c48.2 0 90.8-31.8 104.4-78.4l102.6-360.6c12.6-44.2-1.6-91.8-34.6-124.6zM235.2 868.6h-54.4v-281.2h54.4v281.2z" fill="currentColor"/>
                                </svg>
                            </div>
                        </div>
                        <div class="bydyw-search-bar">
                            <input class="bydyw-search-input" type="text" v-model="searchKeyword" placeholder="请输入关键词" @keyup.enter="handleSearch" />
                            <div class="bydyw-search-btn" @click="handleSearch">搜索</div>
                        </div>
                    </div>
                </div>

                <!-- 主体内容 -->
                <div class="bydyw-info-main">
                    <!-- 左侧目录 -->
                    <div class="bydyw-info-menu">
                        <el-scrollbar class="bydyw-menu-scroll">
                            <div class="menu-unit" v-for="unit in unitList" :key="unit.classId">
                                <div :class="activeUnitId === unit.classId ? 'menu-unit-title active' : 'menu-unit-title'"
                                     @click="selectUnit(unit.classId)">
                                    {{ unit.className }}
                                </div>
                                <div class="menu-lesson-list" v-if="unit.childrenList && unit.childrenList.length > 0">
                                    <div :class="activeLessonId === lesson.classId ? 'menu-lesson-item active' : 'menu-lesson-item'"
                                         v-for="lesson in unit.childrenList" :key="lesson.classId"
                                         @click="selectLesson(unit.classId, lesson.classId)">
                                        {{ lesson.className }}
                                    </div>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>

                    <!-- 右侧视频列表 -->
                    <div class="bydyw-info-content">
                        <el-scrollbar class="bydyw-content-scroll">
                            <div class="bydyw-video-list" v-if="filteredVideoList.length > 0">
                                <div class="bydyw-video-item" v-for="(item, index) in filteredVideoList" :key="index" @click="viewVideo(item)">
                                    <div class="bydyw-video-cover">
                                        <img :src="item.coverUrl" :alt="item.title" />
                                        <div class="bydyw-video-play">
                                            <el-icon class="play-icon"><VideoPlay /></el-icon>
                                        </div>
                                    </div>
                                    <div class="bydyw-video-name" :title="item.title">{{ item.title }}</div>
                                </div>
                            </div>
                            <div class="bydyw-empty" v-else>
                                <div class="empty-icon">
                                    <img src="@/assets/image/data_empty.png" alt="暂无视频" />
                                </div>
                                <div class="empty-text">暂无视频</div>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
        </div>

        <!-- 视频播放弹框 -->
        <el-dialog class="bydyw-video-dialog" :title="videoName" v-model="isViewVideoShow" top="8vh" width="830px" @close="destroyed">
            <div id="bydyw-player"></div>
        </el-dialog>
    </div>
</template>

<script>
import { infoLibrary } from "@/api/admin/classLibrary";
import { addOrCancelCollect, judgeIsCollect } from "@/api/admin/collect";
import { addOrCancelLike, judgeIsLike } from "@/api/admin/likes";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "readBydywInfo",
    data() {
        return {
            loading: false,
            classId: "",
            libraryInfo: {},
            unitList: [],
            allVideoList: [],
            activeUnitId: "",
            activeLessonId: "",
            searchKeyword: "",
            isFavorite: false,
            isLike: false,
            isViewVideoShow: false,
            videoName: "",
            vid: "",
            player: null,
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            videoWidth: 800,
            videoHeight: 500,
        }
    },
    computed: {
        filteredVideoList() {
            const keyword = (this.searchKeyword || '').trim();
            let list = this.allVideoList;
            if (this.activeUnitId) {
                if (this.activeLessonId) {
                    list = list.filter(item => this.matchCourseInfo(item, this.activeLessonId));
                } else {
                    list = list.filter(item => this.matchCourseInfo(item, this.activeUnitId));
                }
            }
            if (keyword) {
                list = list.filter(item => {
                    const title = item.title || '';
                    return title.includes(keyword);
                });
            }
            return list;
        }
    },
    watch: {},
    created() {
        const query = this.$route.query || {};
        if (query.classId) {
            this.classId = query.classId;
            this.queryLibraryInfo();
            this.initCollectLikeState();
        }
    },
    mounted() {},
    methods: {
        /* ===============查询详情===================== */
        queryLibraryInfo() {
            this.loading = true;
            infoLibrary({ classId: this.classId }).then(res => {
                if (res.data.code === 1) {
                    this.libraryInfo = res.data.data || {};
                    this.unitList = this.libraryInfo.childrenList || [];
                    this.allVideoList = this.libraryInfo.videoList || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        /* ===============匹配课程信息===================== */
        matchCourseInfo(item, id) {
            const courseInfo = item.courseInfo || '';
            if (Array.isArray(courseInfo)) {
                return courseInfo.includes(id);
            }
            return courseInfo.includes(id);
        },
        /* ===============选择单元===================== */
        selectUnit(unitId) {
            this.activeUnitId = unitId;
            this.activeLessonId = "";
        },
        /* ===============选择课时===================== */
        selectLesson(unitId, lessonId) {
            this.activeUnitId = unitId;
            this.activeLessonId = lessonId;
        },
        /* ===============收藏/点赞===================== */
        initCollectLikeState() {
            const params = { relationId: this.classId, collectType: 3, businessType: 1 };
            judgeIsCollect(params).then(res => {
                if (res.data.code === 1) {
                    this.isFavorite = !!res.data.data;
                }
            });
            judgeIsLike({ relationId: this.classId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !!res.data.data;
                }
            });
        },
        handleFavorite() {
            const params = { relationId: this.classId, collectType: 3, businessType: 1 };
            addOrCancelCollect(params).then(res => {
                if (res.data.code === 1) {
                    this.isFavorite = !this.isFavorite;
                    this.$message.success(this.isFavorite ? "收藏成功" : "已取消收藏");
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },
        handleLike() {
            addOrCancelLike({ relationId: this.classId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !this.isLike;
                    this.$message.success(this.isLike ? "点赞成功" : "已取消点赞");
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },
        /* ===============播放视频===================== */
        viewVideo(row) {
            this.$router.push({
                path: "/bymy/videoInfo",
                query: { videoId: row.videoId, businessType: 1, collectType: 3 }
            });

        },
        /* ===============搜索===================== */
        handleSearch() {
            // 关键词过滤已由计算属性处理
        },
        /* ===============返回===================== */
        goBack() {
            this.$router.back();
        }
    }
}
</script>

<style scoped>
.bydyw-info-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.bydyw-info-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.bydyw-info-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 标题区 */
.bydyw-info-header {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.bydyw-info-title {
    text-align: center;
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 1px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 28px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
    justify-self: start;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 8px;
    font-size: 16px;
}

/* 主体内容 */
.bydyw-info-main {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
}

/* 左侧目录 */
.bydyw-info-menu {
    width: 240px;
    flex-shrink: 0;
    border-right: 1px solid #e5e7eb;
    padding: 15px 0;
    box-sizing: border-box;
    background-color: #ffffff;
}

.bydyw-menu-scroll {
    width: 100%;
    height: 100%;
}

.menu-unit {
    width: 100%;
    margin-bottom: 12px;
}

.menu-unit-title {
    width: 100%;
    padding: 0 15px;
    font-size: 15px;
    font-weight: bold;
    color: #1f2937;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.2s ease;
}

.menu-unit-title:hover,
.menu-unit-title.active {
    color: #b22222;
    background-color: #fef2f2;
}

.menu-lesson-list {
    width: 100%;
    padding: 4px 0;
}

.menu-lesson-item {
    width: 100%;
    padding: 0 15px 0 28px;
    font-size: 14px;
    color: #4b5563;
    min-height: 28px;
    line-height: 28px;
    cursor: pointer;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.2s ease;
}

.menu-lesson-item:hover,
.menu-lesson-item.active {
    color: #b22222;
    background-color: #fef2f2;
}

/* 右侧内容 */
.bydyw-info-content {
    flex: 1;
    min-width: 0;
    padding: 15px;
    box-sizing: border-box;
    background-color: #ffffff;
}

.bydyw-header-right {
    display: flex;
    align-items: center;
    gap: 14px;
    justify-self: end;
    flex-shrink: 0;
}

.book-actions {
    display: flex;
    align-items: center;
    gap: 14px;
}

.action-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9ca3af;
    cursor: pointer;
    transition: all 0.2s ease;
}

.action-btn:hover,
.action-btn.active {
    color: #b22222;
}

.bydyw-search-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex-shrink: 0;
    justify-self: end;
}

.bydyw-search-input {
    width: 200px;
    height: 34px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.bydyw-search-input:focus {
    border-color: #b22222;
}

.bydyw-search-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.bydyw-search-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

.bydyw-content-scroll {
    width: 100%;
    flex: 1;
    min-height: 0;
}

.bydyw-video-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.bydyw-video-item {
    width: calc(25% - 12px);
    flex-shrink: 0;
    cursor: pointer;
    transition: all 0.25s ease;
}

.bydyw-video-item:hover {
    transform: translateY(-4px);
}

.bydyw-video-cover {
    width: 100%;
    aspect-ratio: 16 / 9;
    background-color: #f3f4f6;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
}

.bydyw-video-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.bydyw-video-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #b22222;
    border-radius: 50%;
    opacity: 0.9;
    transition: all 0.2s ease;
}

.play-icon {
    font-size: 28px;
    color: #fff;
}

.bydyw-video-item:hover .bydyw-video-play {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1);
}

.bydyw-video-name {
    width: 100%;
    min-height: 40px;
    line-height: 20px;
    font-size: 14px;
    color: #1f2937;
    font-family: sans-serif;
    padding-top: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    box-sizing: border-box;
}

/* 空态 */
.bydyw-empty {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.bydyw-empty .empty-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
}

.bydyw-empty .empty-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.bydyw-empty .empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

@media (max-width: 1024px) {
    .bydyw-info-menu { width: 200px; }
    .bydyw-video-item { width: calc(33.333% - 10.667px); }
}

@media (max-width: 768px) {
    .bydyw-info-header { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; }
    .bydyw-info-title { width: 100%; text-align: center; padding: 0; }
    .bydyw-header-right { width: 100%; }
    .bydyw-search-bar { width: 100%; justify-self: auto; }
    .bydyw-search-input { flex: 1; }
    .bydyw-info-main { flex-direction: column; }
    .bydyw-info-menu { width: 100%; height: 180px; border-right: none; border-bottom: 1px solid #e5e7eb; }
    .bydyw-info-content { flex: 1; }
    .bydyw-video-item { width: calc(50% - 8px); }
}
</style>
